import api from 'base/utils/api';
import { IDrawApi, IDrawResultCoupon, IWheelConfigData } from '@base/activity/CouponDrawWheel/interface';

/**
 * 获取大转盘转盘配置
 */
export function getWheelConfig(): Promise<IWheelConfigData> {
    return api.get('/web/spin/wheel/config');
}


export function spinWheelDraw(params: IDrawApi): Promise<IDrawResultCoupon> {
    return api.post('/web/spin/wheel/draw', {
        data: params
    });
}

